<template>
  <span>{{ value | numberFormat }} {{ $t('Currency') }}</span>
</template>

<script>

export default {
  name: 'DisplayCurrency',
  props: {
    value: {
      type: String,
      default: () => '',
    },
  },
}
</script>

<style scoped></style>
